import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LogService } from '../services/log.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  private logService = inject(LogService);

  handleError(error: Error) {
    this.logService.logException(error);
    throw error;
  }
}
